import { render } from "./Requerimientos.vue?vue&type=template&id=a6d1bacc"
import script from "./Requerimientos.vue?vue&type=script&lang=js"
export * from "./Requerimientos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__